import { render, staticRenderFns } from "./dtDesc.vue?vue&type=template&id=2d43799c&scoped=true"
import script from "./dtDesc.vue?vue&type=script&lang=js"
export * from "./dtDesc.vue?vue&type=script&lang=js"
import style0 from "./dtDesc.vue?vue&type=style&index=0&id=2d43799c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43799c",
  null
  
)

export default component.exports